import { render } from "./Index.vue?vue&type=template&id=62ec4b4a&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=62ec4b4a&lang=scss&scoped=true"

import exportComponent from "C:\\WORK\\MAPO\\hrm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ec4b4a"]])

export default __exports__